// The upgrade page's plan prices from the server: v2's catalogue (GET /v2/catalogue/plans, through the doorway's
// `billing` area: src/lib/api/billing.ts) for a visitor room 2's switch puts on v2. Everyone else, and anyone v2
// can't answer, keeps plan-facts.js, as v1 has no call that answers plan prices: those figures are v1's own.
import { planPrices } from './api/billing.ts'

/** v2's `{ sale, plans }`, or null when this visitor isn't on v2 or the answer cannot be had. */
export async function fetchPlanPrices(token, ask = planPrices) {
  try {
    const response = await ask(token)
    if (!response?.ok) return null
    const answer = await response.json()
    return answer?.plans && typeof answer.plans === 'object' ? answer : null
  } catch {
    return null
  }
}

/** plan-facts.js' plans with the server's prices in, plan by plan; without an answer, the plans as they are. */
export function withServerPlans(facts, answer) {
  if (!answer?.plans) return facts
  return Object.fromEntries(
    Object.entries(facts).map(([key, plan]) => [
      key,
      answer.plans[key] ? { ...plan, ...answer.plans[key] } : plan,
    ]),
  )
}
